import * as actions from '../../utils/Actions';

const initialState = {
    showPageLoader: false,
    searchedStudent: null,
    studentDetails: null,
    updateSummaryStatus:null,
    isCaptchaRejected: false,
    encodedKeyData : null,
    erpStudentResponse:null
}

export default function student(state = initialState, action) {

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type) {

        case actions.RESET_STUDENT_DETAILS:
            return {
                ...state,
                studentDetails: null,
                updateSummaryStatus:null,
                searchedStudent: null,                
            }
        
        case actions.pending(actions.SEARCH_STUDENT):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.SEARCH_STUDENT):
            return {
                ...state,
                showPageLoader: false,
                searchedStudent: action.payload.data,
                isCaptchaRejected: false,
                erpStudentResponse:null
            }

        case actions.rejected(actions.SEARCH_STUDENT):
            return {
                ...state,
                showPageLoader: false,
                isCaptchaRejected: true,
                erpStudentResponse:null
            }

        case actions.pending(actions.GET_STUDENT_DETAILS):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_STUDENT_DETAILS):
            return {
                ...state,
                showPageLoader: false,
                studentDetails: action.payload.data
            }

        case actions.rejected(actions.GET_STUDENT_DETAILS):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.UPDATE_SUNMMARY):
            return {
                ...state,
                showPageLoader: true,
                updateSummaryStatus:null
            }

        case actions.fulfilled(actions.UPDATE_SUNMMARY):
            return {
                ...state,
                showPageLoader: false,
                updateSummaryStatus: action.payload.data
            }

        case actions.rejected(actions.UPDATE_SUNMMARY):
            return {
                ...state,
                showPageLoader: false
            }
        
        case actions.pending(actions.GET_STUDENT_BY_ID):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_STUDENT_BY_ID):
            return {
                ...state,
                showPageLoader: false,
                searchedStudent: action.payload.data
            }

        case actions.rejected(actions.GET_STUDENT_BY_ID):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.SEARCH_ERP_STUDENT):
            return {
                ...state,
                showPageLoader: true,
                erpStudentResponse:null
            }

        case actions.fulfilled(actions.SEARCH_ERP_STUDENT):
            return {
                ...state,
                showPageLoader: false,
                searchedStudent: action.payload.data,
                erpStudentResponse:null
            }

        case actions.rejected(actions.SEARCH_ERP_STUDENT):
            return {
                ...state,
                showPageLoader: false,
                searchedStudent: action.payload.data.data,
                erpStudentResponse:action.payload.data
            }

        case actions.pending(actions.GET_ENCODED_KEY):
            return {
                ...state,
                showPageLoader: true,
                encodedKeyData:null
            }

        case actions.fulfilled(actions.GET_ENCODED_KEY):
            return {
                ...state,
                showPageLoader: false,
                encodedKeyData: action.payload.data
            }

        case actions.rejected(actions.GET_ENCODED_KEY):
            return {
                ...state,
                showPageLoader: false
            }
            

        default:
            return { ...state }
    }
} 
